export default __webpack_public_path__ + "static/media/netlify-logo.6958f208.png";